import React from "react";
import Grid from "@material-ui/core/Grid";
import ErrorIcon from "@material-ui/icons/Error";
import {not_validate_value} from "../App";

export const ErrorBox = props =>{
        if (!not_validate_value(props.errorMsg)) {
            return(
        <Grid item xs={12} className="error-box">
            <ErrorIcon className="m-3"/>
            {props.errorMsg}
        </Grid>
    )}
        return "";
}